import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatDialogModule } from "@angular/material/dialog";
import { PopupMessageModalComponent } from "./popup-message-modal.component";

@NgModule({
  declarations: [PopupMessageModalComponent],
  imports: [CommonModule, MatButtonModule, MatIconModule, MatDialogModule],
  exports: [PopupMessageModalComponent],
})
export class PopupMessageModalModule {}
